<template lang="pug">
div(
    :class="{ small: small, large: large }"
    :style="containerStyle"
    class="tl-badge"
)
    span(
        :style="textStyle"
        class="tl-badge-text"
    )
        slot
</template>

<script setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    small: Boolean,
    large: Boolean,
    color: String,
    opaq: Boolean,
    outlined: Boolean,
})

const injects = getInjects(props, inject)

const opaq = computed(() => props.opaq ?? injects.opaq)
const small = computed(() => props.small ?? injects.small)
const large = computed(() => props.large ?? injects.large)
const outlined = computed(() => props.outlined ?? injects.outlined)
const color = computed(() => props.color ?? injects.color ?? 'tl-blue')

const containerStyle = computed(() => {
    const out = {}

    if (opaq.value) {
        out.backgroundColor = `var(--color-${color.value}-tint-extralight)`
    } else if (outlined.value) {
        out.boxShadow = `0 0 0px 1px var(--color-${color.value})`
    } else {
        out.backgroundColor = `var(--color-${color.value})`
    }

    return out
})

const textStyle = computed(() => {
    const out = {}

    if (opaq.value || outlined.value) {
        out.color = `var(--color-${color.value})`
    } else {
        out.color = 'var(--color-white-preserve)'
    }

    return out
})
</script>

<style lang="sass" scoped>
.tl-badge
    height: 26px
    border-radius: 15px
    display: inline-flex
    align-items: center
    padding: 0 var(--padding-3)
    .tl-badge-text
        color: var(--color-white)
        text-transform: uppercase
        font-family: var(--font-family-primary)
        font-size: 12px
        letter-spacing: 1px
        font-weight: var(--font-weight-semibold)
    &.large
        height: 38px
        border-radius: 20px
        padding: 0 var(--padding-4)
        .tl-badge-text
            font-size: 14px
    &.small
        height: 20px
        border-radius: 10px
        padding: 0 var(--padding-2)
        .tl-badge-text
            font-size: 10px
</style>
